import React from 'react';

// Light-hero accents shared by the Health & Insights pages: thin teal brand rule + faint indigo/teal radial glow.
export function HeroAccents() {
  return (
    <>
      <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-teal-400 via-teal-500 to-teal-400 pointer-events-none" aria-hidden="true" />
      <div className="absolute inset-0 opacity-[0.08] pointer-events-none" aria-hidden="true"
        style={{ backgroundImage: 'radial-gradient(circle at 20% 50%, #6366f1 0%, transparent 50%), radial-gradient(circle at 80% 50%, #14b8a6 0%, transparent 50%)' }} />
    </>
  );
}

// One theme for every Health & Insights hero so the pages can't drift apart.
export function healthHeroTheme(isDark, getSectionTheme, getLightSectionTheme) {
  return isDark
    ? { ...getSectionTheme('ROE'), heroGradient: 'bg-[#0a0f1c]', bodyTint: 'bg-[#0a0f1c]', textBase: 'text-white', textLight: 'text-slate-300', textLighter: 'text-slate-400', titleClass: 'text-slate-50 font-extrabold' }
    : getLightSectionTheme('ROE');
}
